import React, { memo, forwardRef } from "react";
const SvgPrecipitate = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M21.707 22.707a1 1 0 00-1.414-1.414L17 24.586V5a1 1 0 10-2 0v19.586l-3.293-3.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0l5-5z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgPrecipitate.displayName = "SvgPrecipitate";
const MemoForwardRef = memo(SvgPrecipitate);
export default MemoForwardRef;
